import PropTypes from 'prop-types'
import { View } from './View'
import { toaster } from '@appkit4/react-components/notification'

/**
 * Appkit4 PopBannerコンポーネントは
 * <a href="https://appkit.pwc.com/appkit4/content/notification?variation=global-notification&state=error&version=react&modifier=icon-timed" target="_blank">こちら</a>
 *
 * showPopBanner 関数を使用することで、任意のタイミングで表示できる<br>
 * ※ PopBanner コンポーネント単体では timer が利用できません。 showPopBanner 関数を使用してください。<br>
 * ※ 使用方法は withButton のコード参照
 */
export const PopBanner = ({ ...props }) => {
    return <View {...props} />
}

export const showPopBanner = ({ duration, ...props }) => {
    toaster.notify(<PopBanner {...props} />, { position: 'topHeader', showTimer: !!duration, duration })
}

PopBanner.propTypes = {
    /**
     * ステータスアイコン<font color="red">*</font>
     */
    status: PropTypes.oneOf(['success', 'error']).isRequired,
    /**
     * メッセージ<font color="red">*</font>
     */
    message: PropTypes.node.isRequired,
    /**
     * 表示時間（ミリ秒）
     */
    duration: PropTypes.number,
    /**
     * スタイル変更用のクラス名
     */
    className: PropTypes.any
}
